import { Box, Button, IconButton } from '../../../../../../base-components';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Moment } from 'moment/moment';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { IActiveFilter } from '../../../../../table.interfaces';
import { useTranslation } from 'react-i18next';

interface IDateRangeMenuProps {
    activeFilters: Array<IActiveFilter>;
    activeFilterIndex: number;
    handleDateRangeChange: (
        newValue: [Moment | null, Moment | null],
        index: number
    ) => void;
    handleClearStartDate: (index: number) => void;
    handleClearEndDate: (index: number) => void;
}

const DateRangeMenu = (props: IDateRangeMenuProps) => {
    const {
        activeFilters,
        activeFilterIndex,
        handleDateRangeChange,
        handleClearStartDate,
        handleClearEndDate,
    } = props;
    const { t } = useTranslation();
    return (
        <Box padding={2}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <DatePicker
                    label={t('filters.startDate')}
                    value={
                        (
                            activeFilters[activeFilterIndex].values as [
                                Moment | null,
                                Moment | null,
                            ]
                        )[0]
                    }
                    onChange={(newValue) =>
                        handleDateRangeChange(
                            [
                                newValue,
                                (
                                    activeFilters[activeFilterIndex].values as [
                                        Moment | null,
                                        Moment | null,
                                    ]
                                )[1],
                            ],
                            activeFilterIndex
                        )
                    }
                />
                <IconButton
                    onClick={() => handleClearStartDate(activeFilterIndex)}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginTop={1}
            >
                <DatePicker
                    label={t('filters.endDate')}
                    value={
                        (
                            activeFilters[activeFilterIndex].values as [
                                Moment | null,
                                Moment | null,
                            ]
                        )[1]
                    }
                    onChange={(newValue) =>
                        handleDateRangeChange(
                            [
                                (
                                    activeFilters[activeFilterIndex].values as [
                                        Moment | null,
                                        Moment | null,
                                    ]
                                )[0],
                                newValue,
                            ],
                            activeFilterIndex
                        )
                    }
                />
                <IconButton
                    onClick={() => handleClearEndDate(activeFilterIndex)}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <Button
                variant="outlined"
                color="secondary"
                onClick={() =>
                    handleDateRangeChange([null, null], activeFilterIndex)
                }
                startIcon={<DeleteIcon />}
                fullWidth
                style={{ marginTop: 8 }}
            >
                {t('filters.clearAllRange')}
            </Button>
        </Box>
    );
};

export default DateRangeMenu;
